import axios from "axios";

import { cleanSearchInput } from "./cleanSearchInput";
import type { IUser } from "@/v1/types";
import api from "@/v1/api";

export type CustomerResolution =
  | { kind: "empty" }
  | { kind: "one"; user: IUser }
  | { kind: "none" }
  | { kind: "several" };

// Turns whatever an operator typed (email, Public ID, Account ID, tax number,
// name) into at most one customer, using the same search the Mandanten view
// uses. The backend classifies the input. Every view then keeps working with
// the customer's real email, because the `/users/:email/...` routes resolve by
// email only (SMT-1396). Two results are enough to know it is ambiguous.
export const resolveCustomer = async (
  input: string
): Promise<CustomerResolution> => {
  const search = cleanSearchInput(input);
  if (!search) {
    return { kind: "empty" };
  }

  let users: Array<IUser>;
  try {
    ({ users } = await api.kontax.getUsers({ search, pageSize: 2 }));
  } catch (error) {
    // The backend answers a search without hits with 404 "User not found"
    // instead of an empty list.
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return { kind: "none" };
    }
    throw error;
  }

  if (users.length === 1) {
    return { kind: "one", user: users[0] };
  }
  return users.length === 0 ? { kind: "none" } : { kind: "several" };
};
